<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>

<div class="container-fluid p-5 w-100">
    <h3>Registrar Venta</h3>
    <div class="d-flex flex-column gap-2 p-3 bg-white shadow border rounded">
        <div class="d-flex gap-3">
            <div class="w-50">
                <h4>Detalles</h4>
                <form [formGroup]="form">
                    <div class="form-group col-12 col-sm">
                        <label for="fecha">Fecha</label>
                        <input type="date" class="form-control"
                            id="fecha" formControlName="fecha"
                            [ngClass]="{'is-invalid': form.controls['fecha'].errors && form.controls['fecha'].touched}">
                        <div class="invalid-feedback">
                            Debe ingresar un valor en el campo
                        </div>
                        <div class="mb-4" *ngIf="!form.controls['fecha'].errors || !form.controls['fecha'].touched">
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="detalle">Detalles</label><label class="campo-opcional"> (Opcional)</label>
                        <textarea class="form-control" id="detalle" rows="6" formControlName="detalle"></textarea>
                    </div>

                </form>
            </div>
            <div class="border"></div>
            <div class="w-100">
                <h4>Productos</h4>
                <div class="d-flex gap-3">
                    <button class="btn btn-primary" (click)="addProducto()"><i class="fas fa-plus"></i> Nuevo
                        Producto</button>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Producto</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Valor Unitario</th>
                            <th scope="col">SubTotal</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of lineas; let index = index">
                            <td style="vertical-align: middle;" class="w-100">
                                <ng-select [ngClass]="{'border rounded border-danger': !item.producto_id}"
                                    [items]="productos" bindValue="id" labelForId="producto"
                                    [searchFn]="searchFnProducto" [virtualScroll]="true" bindLabel="nombre"
                                    [(ngModel)]="item.producto_id" groupBy="tipo"
                                    (change)="productoCambiado($event, index)">
                                    <ng-template ng-label-tmp let-item="item">
                                        {{item.nombre}}
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item" let-index="index"
                                        let-search="searchTerm">
                                        <div class="d-flex justify-content-between px-3">
                                            <div class="d-flex flex-column">
                                                <div *ngIf="item.codigo_barra || item.sku" class="d-flex gap-2"
                                                    style="font-size: small; color: gray;">
                                                    <div>
                                                        <i class="fas fa-barcode"></i>
                                                    </div>
                                                    <div *ngIf="item.codigo_barra">{{item.codigo_barra}}</div>
                                                    <div>-</div>
                                                    <div *ngIf="item.sku">SKU {{item.sku}}</div>
                                                </div>
                                                <div>{{item.nombre}}</div>
                                            </div>
                                            <div *ngIf="item.precio_venta">$
                                                {{formatter.numberFormat(item.precio_venta)}}</div>
                                        </div>

                                    </ng-template>
                                </ng-select>
                            </td>
                            <td style="min-width: 100px;vertical-align: middle;"><input type="text" class="form-control"
                                    [(ngModel)]="item.cantidad" thousandSeparator="." mask="separator.0"
                                    (change)="cantidadCambiada(item)"></td>
                            <td style="min-width: 150px;vertical-align: middle;"><input type="text" class="form-control"
                                    [(ngModel)]="item.precio_unitario" thousandSeparator="." mask="separator.0"
                                    (change)="valorCambiado(item)"></td>
                            <td class="text-right" style="min-width: 130px;vertical-align: middle;">$
                                {{formatter.numberFormat(item.precio_unitario * item.cantidad)}}</td>
                            <td><button class="btn btn-light text-danger" (click)="quitarProducto(index)"><i
                                        class="fas fa-trash"></i></button></td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <button class="btn btn-primary w-100" (click)="agregarProducto()"><i
                                        class="fas fa-plus"></i></button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="3">
                                <div class="d-flex flex-column w-100">
                                    <div class="w-100 text-end">Neto</div>
                                    <div class="w-100 text-end">IVA (19%)</div>
                                    <div class="w-100 text-end">Total</div>
                                </div>
                            </th>
                            <th class="text-right">
                                <div class="d-flex flex-column w-100">
                                    <div class="w-100 text-end">$ {{formatter.numberFormat(total / 1.19, 0,0)}}</div>
                                    <div class="w-100 text-end">$ {{formatter.numberFormat(total / 1.19 * 0.19, 0,0)}}
                                    </div>
                                    <div class="w-100 text-end">$ {{formatter.numberFormat(total)}}</div>
                                </div>
                            </th>
                        </tr>
                    </tfoot>
                </table>
                <div class="d-flex justify-content-between w-100 flex-wrap gap-2">
                    <div class="d-flex flex-column">
                        <h6>Tipo de Documento</h6>
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-primary" [ngClass]="{'active': tipoDocumento == 1}"
                                (click)="tipoDocumento = 1">Boleta</button>
                            <button type="button" class="btn btn-primary" [ngClass]="{'active': tipoDocumento == 2}"
                                (click)="tipoDocumento = 2">Factura</button>
                            <button type="button" class="btn btn-primary" [ngClass]="{'active': tipoDocumento == 3}"
                                (click)="tipoDocumento = 3">Cotización</button>
                        </div>
                    </div>
                    <div class="d-flex flex-column">
                        <h6>Método de Pago</h6>
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-primary"
                                [ngClass]="{'active': tipoPago == 1, 'disabled': tipoDocumento == 3}"
                                (click)="tipoPago = 1">Efectivo</button>
                            <button type="button" class="btn btn-primary"
                                [ngClass]="{'active': tipoPago == 2, 'disabled': tipoDocumento == 3}" (click)="tipoPago = 2">T.
                                Débito</button>
                            <button type="button" class="btn btn-primary"
                                [ngClass]="{'active': tipoPago == 3, 'disabled': tipoDocumento == 3}" (click)="tipoPago = 3">T.
                                Crédito</button>
                            <button type="button" class="btn btn-primary"
                                [ngClass]="{'active': tipoPago == 4, 'disabled': tipoDocumento == 3}"
                                (click)="tipoPago = 4">Transferencia</button>
                            <button type="button" class="btn btn-primary"
                                [ngClass]="{'active': tipoPago == 5, 'disabled': tipoDocumento == 3}"
                                (click)="tipoPago = 5">Cheque</button>
                            <button type="button" class="btn btn-primary"
                                [ngClass]="{'active': tipoPago == 6, 'disabled': tipoDocumento == 3}"
                                (click)="tipoPago = 6">Crédito</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex">
            <div class="d-flex w-100 justify-content-end">
                <button type="button" class="btn btn-success" (click)="guardar()">Registrar</button>
            </div>
        </div>
    </div>
</div>